<template>
  <div class="c-summary">
    <template v-for="item in summary">
      <div
        v-if="item.name === 'logoImage'"
        :key="item.name"
        class="c-summaryRow c-summaryRow-headingBlock c-summaryRow-carousel"
      >
        <div class="c-summaryRow_col c-summaryRowHeading c-summaryRow-headingBlock_heading">
          {{ item.title }}
        </div>
        <div class="c-summaryRow_col c-summaryRowContent c-summaryRowContent-carousel">
          <div v-if="!item.contentJson.length">ー</div>
          <div
            class="c-summaryRowContentImages"
            v-else
          >
            <div
              class="c-summaryRowContentImagesItem"
              v-for="(content, index) in item.contentJson"
              :key="index"
            >
              <div class="c-summaryRowContentImagesItem_image">
                <div class="c-summaryRowContentImagesItem_imageInner">
                  <img :src="content.imageFileUrl">
                </div>
              </div>
              <div class="c-summaryRowContentImagesItem_caption">
                {{ content.label }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else-if="item.name === 'desiredColorImage'"
        :key="item.name"
        class="c-summaryRow"
      >
        <div class="c-summaryRow_col c-summaryRowHeading">
          {{ item.title }}
        </div>
        <div class="c-summaryRow_col c-summaryRowContent">
          <div v-if="!item.contentJson.length">ー</div>
          <div
            class="c-summaryRowContentWithColor"
            v-for="(content, index) in item.contentJson"
            :key="index"
          >
            <span class="c-summaryRowContentWithColor_content">
              {{ content.text ? content.text : content.label }}
            </span>
            <span
              class="c-summaryRowContentWithColor_color"
              :style="{ background: content.color }"
              v-if="content.color"
            >&nbsp;</span>
          </div>
        </div>
      </div>

      <div
        v-else-if="item.name === 'desiredDirectionDirectivity'"
        :key="item.name"
        class="c-summaryRow c-summaryRow-headingBlock"
      >
        <div class="c-summaryRow_col c-summaryRowHeading c-summaryRow-headingBlock_heading">
          {{ item.title }}
        </div>
        <div class="c-summaryRow_col c-summaryRowContent">
          <div v-if="!item.contentJson.length">ー</div>
          <div
            class="c-summaryRowContentSlider"
            v-for="(content, index) in item.contentJson"
            :key="index"
          >
            <div
              class="c-summaryRowContentSlider_prefix"
              v-if="$util.hasPath(content, 'range.left')"
            >
              {{ content.range.left }}
            </div>
            <div
              class="c-summaryRowContentSlider_slider"
              v-if="content.items"
            >
              <c-slider
                :disabled="true"
                type="request-detail"
                :dotSize="14"
                height="4"
                :bgStyle="BG_STYLE"
                :processStyle="PROCESS_STYLE"
                :piecewiseStyle="PIECEWISE_STYLE"
                :piecewiseActiveStyle="PIECEWISE_ACTIVE_STYLE"
                :values="sliderValues(content.items)"
                :min="sliderMinLevel(content.items)"
                :max="sliderMaxLevel(content.items)"
                v-model="content.value"
              />
            </div>
            <div
              class="c-summaryRowContentSlider_suffix"
              v-if="$util.hasPath(content, 'range.right')"
            >
              {{ content.range.right }}
            </div>
          </div>
        </div>
      </div>

      <div
        v-else-if="item.name === 'targetAge'"
        :key="item.name"
        class="c-summaryRow"
      >
        <div class="c-summaryRow_col c-summaryRowHeading">
          {{ item.title }}
        </div>
        <div class="c-summaryRow_col c-summaryRowContent c-summaryRowContent-withHeading">
          <div v-if="!item.contentJson.length">ー</div>
          <div
            class="c-summaryRowContentWithHeading"
            v-for="(content, index) in item.contentJson"
            :key="index"
          >
            <span class="c-summaryRowContentWithHeading_heading">
              {{ content.subTitle }}
            </span>
            <span class="c-summaryRowContentWithHeading_content">
              {{ implodeContentText(content.values) }}
            </span>
          </div>
        </div>
      </div>

      <div
        v-else
        :key="item.name"
        class="c-summaryRow"
      >
        <div class="c-summaryRow_col c-summaryRowHeading">
          {{ item.title }}
        </div>
        <div class="c-summaryRow_col c-summaryRowContent">
          {{ implodeContentText(item.contentJson) }}
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import CSlider from '~/components/molecules/CSlider'

const BG_STYLE = {
  backgroundColor: '#ddd'
}

const PROCESS_STYLE = {
  backgroundColor: '#ddd'
}

const PIECEWISE_STYLE = {
  visibility: 'visible',
  width: '2px',
  height: '8px',
  backgroundColor: '#ddd'
}

const PIECEWISE_ACTIVE_STYLE = {
  backgroundColor: '#ddd'
}

export default {
  name: 'ContentsSummary',
  components: {
    CSlider
  },
  props: {
    summary: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      BG_STYLE,
      PROCESS_STYLE,
      PIECEWISE_STYLE,
      PIECEWISE_ACTIVE_STYLE
    }
  },
  methods: {
    implodeContentText(contents) {
      if (!contents || !contents.length) {
        return 'ー'
      }

      let text = ''
      contents.forEach((content, index) => {
        let contentText = content.text ? content.text : content.label
        if (content.unit && /^\d+$/.test(contentText)) {
          // 数字+単位の場合
          contentText = this.$util.numberWithDelimiter(contentText) + content.unit
        }
        text += contentText
        if (index < contents.length - 1) {
          text += '、'
        }
      })
      return text
    },
    sliderValues(items) {
      return items.map(item => ({
        value: item.value
      }))
    },
    sliderMinLevel(items) {
      return items[0]
    },
    sliderMaxLevel(items) {
      return items[items.length - 1]
    }
  }
}
</script>
<style lang="scss" scoped>
.c-summaryRow {
  display: flex;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.c-summaryRowHeading {
  flex: 0 0 130px;
  margin-right: 36px;
  font-weight: bold;
}

.c-summaryRowContent {
  flex: 1 1 auto;

  &-carousel {
    display: flex;
  }

  &-withHeading {
    display: flex;

    flex-wrap: wrap;
  }
}

.c-summaryRowContentWithHeading {
  display: flex;
  margin-right: 30px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  &_heading {
    display: inline-block;
    margin-right: 8px;
    padding: 0 8px;
    height: 20px;
    background: $color-gray-50;
    white-space: nowrap;
    font-size: 12px;
    line-height: 20px;
  }
}

.c-summaryRowContentWithColor {
  display: flex;
  margin-right: 30px;

  align-items: center;

  &_content {
    display: inline-block;
    margin-right: 8px;
  }

  &_color {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    background: $color-gray-50;
    font-size: 16px;
    line-height: 1;
  }
}

.c-summaryRowContentImages {
  display: flex;

  flex-wrap: wrap;

  .c-summaryRowContentImagesItem {
    flex: 0 0 106px;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 4px;
    width: 106px;
    height: 80px;
    border: 1px solid $color-gray-200;
    border-radius: 6px;

    &_image {
      display: flex;
      margin: 4px 4px 8px;
      height: 40px;

      align-items: center;
      flex-basis: 100%;
      justify-content: center;
    }

    &_imageInner {
      width: 80px;
    }

    &_caption {
      overflow: hidden;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 10px;
    }
  }
}

.c-summaryRowContentSlider {
  display: flex;
  margin-bottom: 8px;
  height: 20px;

  align-items: center;

  &_prefix {
    flex: 0 0 60px;
    margin-right: 8px;
    text-align: right;
    font-size: 12px;
  }

  &_slider {
    flex: 0 0 160px;
  }

  &_suffix {
    flex: 0 0 60px;
    margin-left: 8px;
    font-size: 12px;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-summaryRow {
    margin-bottom: 0;
    padding: 12px;

    & + & {
      border-top: 1px solid $color-gray-50;
    }

    &-headingBlock {
      flex-wrap: wrap;

      &_heading {
        margin-bottom: 8px;

        flex-basis: 100% !important;
      }
    }

    &-carousel {
      padding-right: 0;
    }
  }

  .c-summaryRowHeading {
    flex: 0 0 100px;
    margin-right: 8px;
  }

  .c-summaryRowContentWithHeading {
    margin-right: 0;

    flex-basis: 100%;

    &_heading {
      font-size: 10px;
    }
  }

  .c-summaryRowContentWithColor {
    display: block;
    margin-right: 0;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    &_color {
      display: inline-block;
      font-size: 15px;
    }
  }

  .c-summaryRowContentImages {
    flex-wrap: nowrap;

    .c-summaryRowContentImagesItem {
      margin-bottom: 0;
    }
  }

  .c-summaryRowContent {
    &-carousel {
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      white-space: nowrap;
    }
  }
}
</style>
